import { createRouter, createWebHistory } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'
import generatedRoutes from 'virtual:generated-pages'
import { useTalleresStore } from '@/stores/talleres'
import { useAuthStore } from '@/stores/auth'
import { miUsuario } from '@/services/usuarios'

// Process routes with layouts
const routes = setupLayouts(generatedRoutes)

routes.push(
  {
    path: '/admin/gestion-talleres',
    component: () => import('@/pages/admin/gestion-talleres/index.vue'),
    meta: {
      title: 'Crear Taller',
      requiresAuth: true
    }
  },
  {
    path: '/admin/gestion-talleres/lista',
    component: () => import('@/pages/admin/gestion-talleres/lista.vue'),
    meta: {
      title: 'Lista de Talleres',
      requiresAuth: true
    }
  },
  {
    path: '/admin/gestion-talleres/editar/:id',
    component: () => import('@/pages/admin/gestion-talleres/editar/[id].vue'),
    meta: {
      title: 'Editar Taller',
      requiresAuth: true
    }
  },
  {
    path: '/docente/login',
    component: () => import('@/pages/docente/login.vue'),
    meta: {
      title: 'Ingreso Docentes',
      layout: 'login'
    }
  },
  {
    path: '/docente',
    component: () => import('@/pages/docente/index.vue'),
    meta: {
      title: 'Panel de Docente',
      requiresAuth: true,
      header: true,
      footer: true
    }
  },
  {
    path: '/docente/taller/:id',
    component: () => import('@/pages/docente/[id].vue'),
    meta: {
      title: 'Detalle del Taller',
      requiresAuth: true,
      header: true,
      footer: true
    }
  }
)

// Create router
const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

// Necesito agregar una ruta
// Para el path /virtuales/[autor]/[taller]/anecdotas/[id]
// Si no tiene el id, redirigir a /virtuales/[autor]/[taller]/anecdotas/mia
// Solo para la ruta completa
router.beforeEach((to, from, next) => {
  console.log(to)
  if (
    (to.path === "/virtuales/hernan-casciari/taller-marzo/anecdotas" || to.path === "/virtuales/hernan-casciari/taller-marzo/anecdotas/")

    && !to.params.id) {
    next({ path: "/virtuales/hernan-casciari/taller-marzo/anecdotas/mia" })
  } else {
    next()
  }
})

// Error handler
router.onError((error) => {
  console.error('Vue Router error:', error)
})

// En la configuración del router
router.beforeEach(async (to, from, next) => {
  const talleresStore = useTalleresStore()
  const authStore = useAuthStore()

  // Cambiar el document.title según la ruta
  if (to.meta.title)
    document.title = `${to.meta.title} | Escuela | Comunidad Orsai`

  // Verificar autenticación para rutas protegidas
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // Si la ruta es del panel de docentes, redirigir al login de docentes
    if (to.path.startsWith('/docente')) {
      return next('/docente/login')
    }
    return next('/ingresar')
  }

  // Si el usuario está autenticado y trata de acceder al login de docentes, redirigir al panel
  if (to.path === '/docente/login' && authStore.isAuthenticated) {
    return next('/docente')
  }

  next()
})

export default router